<script setup>
    import { useFormModalControlsStore } from '../stores/FormModalControls'
    import { storeToRefs } from "pinia";
    import { watch } from "vue";
    import FormModalLayout from './FormModalLayout'

    const formModalControls = useFormModalControlsStore(),
          { formModalTitle, formModalVisible } = storeToRefs(formModalControls),
          { formModalClose } = formModalControls

    watch( formModalVisible, handleUpdate )

    function handleUpdate(currentValue) {
        if (currentValue) {
            document.documentElement.classList.add('scroll-lock')
        } else {
            document.documentElement.classList.remove('scroll-lock')
        }
    }
</script>

<template>
	<FormModalLayout
		:open="formModalVisible"
        @close="formModalClose()"
	>
		<template #title>
			<h3 id="video-modal__title" class="font-bold text-sm md:text-normal lg:text-lg md:text-2xl my-0">{{ formModalTitle }}</h3>
		</template>

		<div>
            <slot name="form" />
		</div>
	</FormModalLayout>
</template>
